export default __webpack_public_path__ + "static/media/avatar-mp-3-2.ad307c0f.png";